export type InvitationStatus = 'pending' | 'accepted' | 'declined' | 'cancelled';

export interface TournamentInvitation {
  id: string;
  tournamentId: string;
  inviterId: string;
  inviteeId: string;
  status: InvitationStatus;
  message?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface TournamentInvitationWithDetails extends TournamentInvitation {
  tournamentName: string;
  tournamentType: string;
  tournamentStatus: string;
  userName?: string;
  userEmail?: string;
  userAvatarUrl?: string;
}
